import { c as _c } from "react/compiler-runtime";
import { STORES_API } from 'modules/stores/api/stores-api';
import { StoreListApiInterface } from 'modules/stores/types/stores-interface';
import { useControlledSwr } from 'shared/hooks/use-controlled-swr';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
export const useStoreWithOptinItemsList = shouldFetch => {
  const $ = _c(2);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return useControlledSwr(_temp, fetcher, t1, Boolean(user && shouldFetch));
};
function _temp() {
  return `${STORES_API}/choice-list-tmp?items.type=optin`;
}